<template>
  <div class="k-collections-topbar ui-container-widget ui-container-lg">
    <div class="collection-topbar-header">
      <h2 class="ui-h2" v-if="data?.title" v-html="mentionToText(data.title)"></h2>

      <div class="text-right ml-auto">
        <div class="d-flex justify-end ml-auto gap-2">
          <!-- Searchbar -->
          <ui-input v-if="data?.data?.options?.search?.show_searchbar" v-model="searchText" @change="onSearch"
            placeholder="Zoeken" hide_label name="search" />
          <v-btn v-if="data?.data?.options?.search?.show_searchbar" class="ui-btn ui-btn-icon" @click="onSearch"
            :disabled="!searchText">
            <ui-icon name="search" />
          </v-btn>
          <!-- Filters -->
          <in-app-filter v-if="data?.data?.options?.in_app_filter" :filters="data?.data?.options?.in_app_filter.filters"
            :collection_data="collectionData" @apply-filters="onApplyFilters" />
          <!-- Custom Actions -->
          <action-buttons :actions="data?.data?.custom_actions"> </action-buttons>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import wh from "@/helpers/widgetsHelpers.js";

export default {
  name: "CollectionsTopbar",
  props: {
    data: {
      type: Object,
      required: true,
    },
    collectionData: {
      type: Array,
      default: () => [],
    },
    modelValue: {
      type: String,
      default: "",
    },
  },
  emits: ["update:modelValue", "update:search-collection", "apply-filters", "add-item"],

  data() {
    return {
      searchText: "",
    };
  },
  methods: {
    onSearch() {
      this.$emit("update:search-collection", this.searchText);
    },

    searchcollectionEmpty() {
      if (this.searchText) {
        return true;
      } else {
        return false;
      }
    },
    onApplyFilters(filters) {
      this.$emit("apply-filters", filters);
    },
    mentionToText(text) {
      return wh.mentionToText(text, this.data);
    },
  },
};
</script>
<style>
.k-collections-topbar {
  position: relative;
  z-index: 2;

  .collection-topbar-header {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    align-items: center;
  }
}
</style>
